import React from "react";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import AffiliateHeader from "./Header";

function DashboardLayoutAffiliate() {
  return (
    <Box
      sx={{
        display: "block",
        backgroundColor: "transparent",
        position: "relative",
        height: "100vh",
      }}
    >
      <CssBaseline />
      <AffiliateHeader />
      <Box
        className="px-1 px-md-2 pt-5 pb-2 zoom dashboard-h"
        component="div"
        style={{ backgroundColor: "#fff", overflowY: "auto" }}
        sx={{
          marginLeft: { md: "auto" },
          width: { md: "calc(100% - 250px)" },
        }}
      >
        <Toolbar variant="dense" />
        <div className="pt-lg-0 pt-5">
          <Outlet />
        </div>
      </Box>
    </Box>
  );
}

export default DashboardLayoutAffiliate;
